export default "__VITE_ASSET__07746b5f__"